import styled from 'styled-components';

export const EditContainer = styled.div`
  & > div {
    margin-bottom: 16px;
  }
  form {
    display: grid;
    grid-template-columns: 1fr 1fr 2fr;
    @media (max-width: 1024px) {
      grid-template-columns: 1fr 1fr;
    }
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
`;

export const GridElement = styled.div`
  width: 288px;
  margin-right: 48px;
`;
